/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query'
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { customInstance } from '../../mutator'
import type { GetDesignForcesPerSupport200, HTTPValidationError } from '../fastAPI.schemas'

/**
 * @summary Get Design Forces Per Support
 */
export const getDesignForcesPerSupport = (projectGuid: string, signal?: AbortSignal) => {
  return customInstance<GetDesignForcesPerSupport200>({
    url: `/projects/${projectGuid}/design-forces-per-support`,
    method: 'GET',
    signal,
  })
}

export const getGetDesignForcesPerSupportQueryKey = (projectGuid?: string) => {
  return [`/projects/${projectGuid}/design-forces-per-support`] as const
}

export const getGetDesignForcesPerSupportQueryOptions = <
  TData = Awaited<ReturnType<typeof getDesignForcesPerSupport>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDesignForcesPerSupport>>, TError, TData>
  },
) => {
  const { query: queryOptions } = options ?? {}

  const queryKey = queryOptions?.queryKey ?? getGetDesignForcesPerSupportQueryKey(projectGuid)

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getDesignForcesPerSupport>>> = ({
    signal,
  }) => getDesignForcesPerSupport(projectGuid, signal)

  return { queryKey, queryFn, enabled: !!projectGuid, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getDesignForcesPerSupport>>,
    TError,
    TData
  > & { queryKey: QueryKey }
}

export type GetDesignForcesPerSupportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getDesignForcesPerSupport>>
>
export type GetDesignForcesPerSupportQueryError = HTTPValidationError

/**
 * @summary Get Design Forces Per Support
 */

export function useGetDesignForcesPerSupport<
  TData = Awaited<ReturnType<typeof getDesignForcesPerSupport>>,
  TError = HTTPValidationError,
>(
  projectGuid: string,
  options?: {
    query?: UseQueryOptions<Awaited<ReturnType<typeof getDesignForcesPerSupport>>, TError, TData>
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const queryOptions = getGetDesignForcesPerSupportQueryOptions(projectGuid, options)

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey }

  query.queryKey = queryOptions.queryKey

  return query
}
